
import { defineComponent } from "vue";

export default defineComponent({
  name: "PageHeader",
  props: {
    content: {
      type: String,
      default: "",
    },
  },
});
